import React, {Component} from 'react';
import './PictureModal.css'

class PictureModal extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }
    render() {
      return (
      <div class="d-flex modal_picture">
          <img className="image-modal-visu" src={this.props.myPicture} alt="ideaPicture"/>
      </div>
      )
    }
  }


  export default PictureModal;